import Attivita from './Attivita';
import {minutesToHuman} from '../Helpers'

class AttivitaPerAnno extends Attivita {

    createPdf(items){

        const columns = [
            {title: "Colore", dataKey: "colore"},
            {title: "Commessa", dataKey: "com"},
            {title: "Num sessioni", dataKey: "ses"},
            {title: "Durata Totale\n(h:m:s)", dataKey: "duratahms"},
        ];
        let rows = [];
        let numAttivitaTot = 0;
        let durataPesataTot = 0;

        items.map((item) => {
            let it = {
                colore: item.commessa.colore,
                com: item.commessa.nomeCompleto + ' [' + item.commessa.idCommessa + ']',
                ses: item.numAttivita,
                duratahms: minutesToHuman(item.durataPesata),
            };
            rows.push(it);
            numAttivitaTot += item.numAttivita;
            durataPesataTot += item.durataPesata;
            return 0;
        });
        rows.push({
            id: '',
            colore: '',
            com: '',
            ute: '',
            ses: numAttivitaTot,
            duratahms: minutesToHuman(durataPesataTot),
        })


        super.createPdf(columns, rows,
            {
                createdCell: this.doDrawCell,
                drawRow: this.doDrawRow,
                columnStyles: {
                    com: {halign: 'left', columnWidth: 'auto'},
                    ses: {halign: 'center'},
                    duratahms: {halign: 'center'},
                },
                headerStyles: {
                    valign: 'middle',
                    halign: 'center',
                    //fillColor: [0x56, 0x9e, 0xdd],
                    //fillColor: [0xFF, 0xFF, 0xFF],
                    fillColor: false,
                    textColor: [0,0,0],
                    ses:{halign: 'center'},
                    duratahms:{halign: 'center'},
                },
            });
    }
}

export default AttivitaPerAnno;


/** WEBPACK FOOTER **
 ** ./src/pdf/AttivitaPerAnno.js
 **/